// extracted by mini-css-extract-plugin
module.exports = {"head":"Frameworks_head__1u49z","head__button":"Frameworks_head__button__1-lux","summary__section":"Frameworks_summary__section__2hWqc"};